import { useEffect } from "react";

const PAUSE_ENDS = 5000;
const PAUSE_USER = 15000;

export function useAutoScroll(enabled, speed = 30) {
  useEffect(() => {
    if (!enabled) return undefined;
    let raf;
    let last = performance.now();
    let pauseUntil = last + PAUSE_ENDS;
    let pos = window.scrollY;
    const hold = () => {
      pauseUntil = performance.now() + PAUSE_USER;
      pos = window.scrollY;
    };
    const step = (t) => {
      const dt = (t - last) / 1000;
      last = t;
      const max = document.documentElement.scrollHeight - window.innerHeight;
      if (max > 4 && t > pauseUntil) {
        if (pos >= max - 1) {
          window.scrollTo({ top: 0, behavior: "smooth" });
          pos = 0;
          pauseUntil = t + PAUSE_ENDS;
        } else {
          pos = Math.min(max, pos + speed * dt);
          window.scrollTo(0, pos);
          if (pos >= max - 1) pauseUntil = t + PAUSE_ENDS;
        }
      }
      raf = requestAnimationFrame(step);
    };
    raf = requestAnimationFrame(step);
    const events = ["wheel", "touchstart", "keydown", "mousedown"];
    events.forEach((e) => window.addEventListener(e, hold, { passive: true }));
    return () => {
      cancelAnimationFrame(raf);
      events.forEach((e) => window.removeEventListener(e, hold));
    };
  }, [enabled, speed]);
}
